import {
  createActions, asyncInitialState, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null
}, 'ldCommittedProductionOrder');

//const actionListAPI = '/purchaseOrderEnquiry/lookup/action';

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Priority', field: 'Priority', minWidth: 150 },
    { headerName: 'Production order', field: 'ProductionOrder', suppressSorting: true, minWidth: 150 },
    { headerName: 'Committed', field: 'QtyCommittedDisplay', type: 'numericColumn', suppressSorting: true, minWidth: 150 },
    { headerName: 'Resp person', field: 'UserId', type: 'numericColumn', suppressSorting: true, minWidth: 150 },
    { headerName: 'Earliest due', field: 'DueDate', type: 'numericColumn', suppressSorting: true, minWidth: 150 },
    { headerName: 'Order status', field: 'Status', suppressSorting: true, minWidth: 150 },
    { headerName: 'Description', field: 'ProductionOrderDescription', suppressSorting: true, minWidth: 200 }
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clears:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.purchaseOrderEnquiry.ldCommittedProductionOrder,
  {
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.purchaseOrderEnquiry.ldCommittedProductionOrder.loading,
  gridOptions: state => state.purchaseOrderEnquiry.ldCommittedProductionOrder.data.gridOptions,
  Columns: state => state.purchaseOrderEnquiry.ldCommittedProductionOrder.data.Columns,
  Actions: state => state.purchaseOrderEnquiry.ldCommittedProductionOrder.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)